import { render } from "./App.vue?vue&type=template&id=4dfc70c4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4dfc70c4&lang=stylus"

import exportComponent from "G:\\all_project\\all\\hengda-star-region-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__